import { CompanyAccessService } from './company-access/company-access.service';

export { CompanyAccessService };

export default [CompanyAccessService];
